/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as DraftsDraftIdRouteImport } from './routes/drafts.$draftId'
import { Route as WebsitesWebsiteIdDraftsRouteImport } from './routes/websites.$websiteId.drafts'
import { Route as WebsitesWebsiteIdGapsRouteImport } from './routes/websites.$websiteId.gaps'
import { Route as WebsitesWebsiteIdKnowledgeRouteImport } from './routes/websites.$websiteId.knowledge'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const DraftsDraftIdRoute = DraftsDraftIdRouteImport.update({
  id: '/drafts/$draftId',
  path: '/drafts/$draftId',
  getParentRoute: () => rootRouteImport,
} as any)
const WebsitesWebsiteIdDraftsRoute = WebsitesWebsiteIdDraftsRouteImport.update({
  id: '/websites/$websiteId/drafts',
  path: '/websites/$websiteId/drafts',
  getParentRoute: () => rootRouteImport,
} as any)
const WebsitesWebsiteIdGapsRoute = WebsitesWebsiteIdGapsRouteImport.update({
  id: '/websites/$websiteId/gaps',
  path: '/websites/$websiteId/gaps',
  getParentRoute: () => rootRouteImport,
} as any)
const WebsitesWebsiteIdKnowledgeRoute =
  WebsitesWebsiteIdKnowledgeRouteImport.update({
    id: '/websites/$websiteId/knowledge',
    path: '/websites/$websiteId/knowledge',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/drafts/$draftId': typeof DraftsDraftIdRoute
  '/websites/$websiteId/drafts': typeof WebsitesWebsiteIdDraftsRoute
  '/websites/$websiteId/gaps': typeof WebsitesWebsiteIdGapsRoute
  '/websites/$websiteId/knowledge': typeof WebsitesWebsiteIdKnowledgeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/drafts/$draftId': typeof DraftsDraftIdRoute
  '/websites/$websiteId/drafts': typeof WebsitesWebsiteIdDraftsRoute
  '/websites/$websiteId/gaps': typeof WebsitesWebsiteIdGapsRoute
  '/websites/$websiteId/knowledge': typeof WebsitesWebsiteIdKnowledgeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/drafts/$draftId': typeof DraftsDraftIdRoute
  '/websites/$websiteId/drafts': typeof WebsitesWebsiteIdDraftsRoute
  '/websites/$websiteId/gaps': typeof WebsitesWebsiteIdGapsRoute
  '/websites/$websiteId/knowledge': typeof WebsitesWebsiteIdKnowledgeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/drafts/$draftId'
    | '/websites/$websiteId/drafts'
    | '/websites/$websiteId/gaps'
    | '/websites/$websiteId/knowledge'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/drafts/$draftId'
    | '/websites/$websiteId/drafts'
    | '/websites/$websiteId/gaps'
    | '/websites/$websiteId/knowledge'
  id:
    | '__root__'
    | '/'
    | '/connect'
    | '/drafts/$draftId'
    | '/websites/$websiteId/drafts'
    | '/websites/$websiteId/gaps'
    | '/websites/$websiteId/knowledge'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnectRoute: typeof ConnectRoute
  DraftsDraftIdRoute: typeof DraftsDraftIdRoute
  WebsitesWebsiteIdDraftsRoute: typeof WebsitesWebsiteIdDraftsRoute
  WebsitesWebsiteIdGapsRoute: typeof WebsitesWebsiteIdGapsRoute
  WebsitesWebsiteIdKnowledgeRoute: typeof WebsitesWebsiteIdKnowledgeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drafts/$draftId': {
      id: '/drafts/$draftId'
      path: '/drafts/$draftId'
      fullPath: '/drafts/$draftId'
      preLoaderRoute: typeof DraftsDraftIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/websites/$websiteId/drafts': {
      id: '/websites/$websiteId/drafts'
      path: '/websites/$websiteId/drafts'
      fullPath: '/websites/$websiteId/drafts'
      preLoaderRoute: typeof WebsitesWebsiteIdDraftsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/websites/$websiteId/gaps': {
      id: '/websites/$websiteId/gaps'
      path: '/websites/$websiteId/gaps'
      fullPath: '/websites/$websiteId/gaps'
      preLoaderRoute: typeof WebsitesWebsiteIdGapsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/websites/$websiteId/knowledge': {
      id: '/websites/$websiteId/knowledge'
      path: '/websites/$websiteId/knowledge'
      fullPath: '/websites/$websiteId/knowledge'
      preLoaderRoute: typeof WebsitesWebsiteIdKnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnectRoute: ConnectRoute,
  DraftsDraftIdRoute: DraftsDraftIdRoute,
  WebsitesWebsiteIdDraftsRoute: WebsitesWebsiteIdDraftsRoute,
  WebsitesWebsiteIdGapsRoute: WebsitesWebsiteIdGapsRoute,
  WebsitesWebsiteIdKnowledgeRoute: WebsitesWebsiteIdKnowledgeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
